import objectionActions from "./actions";

// null until loaded. API errors are shown as toasts, not kept in state.
const initialState = {
    objNotes : null,
    objQuestions : null,
    // { question, isRaised, isPaid, isEditable, objection } while the objection dialog is open.
    objView : null,
    // { rollno, examname, isOpen, isPaid, totalObjections, objections }
    objSummary : null,
    // { isOpen, isPaid, objections: [{ questionid, questionno, objectiontype, fee }],
    //   totalObjections, perQuestionFee, totalPayable } - or { isOpen, isPaid, message }
    objPaymentSummary : null,
    // { isPaymentDone, receiptno, status, totalAmount, paymentdate, refundReason, isRefundPending }
    objPaymentStatus : null,
    // Same row shape as the application fee receipt list, plus objectionpaymentid, examname,
    // totalobjection and objection_amount.
    objReceiptList : [],
};

const objectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case objectionActions.SET_OBJ_NOTES:
      return {
        ...state,
        objNotes: action.payload,
      };

    case objectionActions.SET_OBJ_QUESTIONS:
      return {
        ...state,
        objQuestions: action.payload,
      };

    case objectionActions.SET_OBJ_VIEW:
      return {
        ...state,
        objView: action.payload,
      };

    case objectionActions.SET_OBJ_SUMMARY:
      return {
        ...state,
        objSummary: action.payload,
      };

    case objectionActions.SET_OBJ_PAYMENT_SUMMARY:
      return {
        ...state,
        objPaymentSummary: action.payload,
      };

    case objectionActions.SET_OBJ_PAYMENT_STATUS:
      return {
        ...state,
        objPaymentStatus: action.payload,
      };

    case objectionActions.SET_OBJ_RECEIPT_LIST:
      return {
        ...state,
        objReceiptList: action.payload,
      };

    default:
      return state;
  }
};

export default objectionReducer;
